import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { waLink, WA_DEFAULT_MSG, PHONE_NUMBER_TEL, PHONE_DISPLAY, EMAIL, ZONES } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-[#060B19] pb-28 pt-16 sm:pb-16" data-testid="footer-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="font-display text-outline text-[13vw] font-black uppercase leading-none tracking-tight lg:text-[9rem]">
          El Mastro
        </p>

        <div className="mt-10 grid gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
          <div>
            <h3 className="font-mono-accent text-xs font-bold uppercase tracking-[0.22em] text-[#FFB800]">
              Contatti diretti
            </h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={waLink(WA_DEFAULT_MSG)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="flex items-center gap-3 text-sm text-slate-300 transition-colors hover:text-[#25D366]"
                >
                  <MessageCircle className="h-4 w-4 text-[#25D366]" />
                  WhatsApp diretto (canale preferito)
                </a>
              </li>
              <li>
                <a
                  href={`tel:${PHONE_NUMBER_TEL}`}
                  data-testid="footer-phone-link"
                  className="flex items-center gap-3 text-sm text-slate-300 transition-colors hover:text-[#FFB800]"
                >
                  <Phone className="h-4 w-4 text-[#FFB800]" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 text-sm text-slate-300 transition-colors hover:text-[#FFB800]"
                >
                  <Mail className="h-4 w-4 text-[#FFB800]" />
                  {EMAIL}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono-accent text-xs font-bold uppercase tracking-[0.22em] text-[#FFB800]">
              Zone coperte a Napoli
            </h3>
            <div className="mt-4 flex flex-wrap gap-2" data-testid="footer-zones-list">
              {ZONES.map((z) => (
                <span
                  key={z}
                  className="flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1 text-xs text-slate-400"
                >
                  <MapPin className="h-3 w-3 text-[#FF5500]" />
                  {z}
                </span>
              ))}
            </div>
            <p className="mt-4 text-xs leading-relaxed text-slate-500">
              Operativi 7/7, 8:00–22:00, festivi inclusi. Arrivo garantito entro 90 minuti nelle zone coperte.
            </p>
          </div>

          <div>
            <h3 className="font-mono-accent text-xs font-bold uppercase tracking-[0.22em] text-[#FFB800]">
              Pagamenti accettati
            </h3>
            <div className="mt-4 flex flex-wrap gap-2" data-testid="footer-payments-list">
              {["POS / Nexi", "Apple Pay", "Satispay", "Bonifico istantaneo", "Visa", "Mastercard"].map((p) => (
                <span key={p} className="rounded-md bg-white/5 px-3 py-1.5 font-mono-accent text-xs text-slate-300">
                  {p}
                </span>
              ))}
            </div>
            <p className="mt-4 text-xs text-slate-500">Mai contanti. Sempre tracciato, sempre con ricevuta.</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} El Mastro — Micro-manutenzioni in scooter a Napoli · P.IVA 08648181215</p>
          <p className="font-mono-accent uppercase tracking-wider">elmastro.it</p>
        </div>
      </div>
    </footer>
  );
}
